<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
  >
    <circle
      cx="9.99995"
      cy="9.99995"
      r="8.92857"
      fill="url(#paint0_linear_12570_70)"
      style=""
    />
    <circle
      cx="9.99995"
      cy="9.99995"
      r="8.92857"
      fill="url(#paint1_linear_12570_70)"
      fill-opacity="0.2"
      style=""
    />
    <circle
      cx="9.99995"
      cy="9.99995"
      r="8.92857"
      stroke="url(#paint2_linear_12570_70)"
      style=""
      stroke-width="0.714286"
    />
    <circle
      cx="9.99998"
      cy="9.99998"
      r="6.42857"
      fill="url(#paint3_linear_12570_70)"
      style=""
    />
    <circle
      cx="9.99998"
      cy="9.99998"
      r="7.5"
      stroke="url(#paint4_linear_12570_70)"
      stroke-opacity="0.84"
      style=""
      stroke-width="2.14286"
      stroke-linejoin="round"
      stroke-dasharray="2.86 2.86"
    />
    <path
      d="M9.84633 8.71157C9.9416 8.65657 10.059 8.65656 10.1543 8.71157L11.0463 9.22661C11.1416 9.28162 11.2003 9.38327 11.2003 9.49328V10.5234C11.2003 10.6334 11.1416 10.735 11.0463 10.79L10.1543 11.3051C10.059 11.3601 9.9416 11.3601 9.84633 11.3051L8.95425 10.79C8.85898 10.735 8.80029 10.6334 8.80029 10.5234V9.49328C8.80029 9.38327 8.85898 9.28162 8.95425 9.22661L9.84633 8.71157Z"
      stroke="white"
      style="stroke:white;stroke-opacity:1;"
      stroke-width="0.72"
      stroke-linejoin="round"
    />
    <path
      d="M9.99988 8.59968V6.79968"
      stroke="white"
      style="stroke:white;stroke-opacity:1;"
      stroke-width="0.72"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.99988 13.1997V11.5997"
      stroke="white"
      style="stroke:white;stroke-opacity:1;"
      stroke-width="0.72"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.1998 9.20002L12.5854 8.40002"
      stroke="white"
      style="stroke:white;stroke-opacity:1;"
      stroke-width="0.72"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.5855 11.6L11.1998 10.8"
      stroke="white"
      style="stroke:white;stroke-opacity:1;"
      stroke-width="0.72"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.58559 9.20002L7.19995 8.40002"
      stroke="white"
      style="stroke:white;stroke-opacity:1;"
      stroke-width="0.72"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.19956 11.6L8.58521 10.8"
      stroke="white"
      style="stroke:white;stroke-opacity:1;"
      stroke-width="0.72"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.37988 6.77344C9.76354 6.55194 10.2365 6.55194 10.6201 6.77344L12.4844 7.84961C12.868 8.07113 13.1045 8.48085 13.1045 8.92383V11.0762C13.1045 11.5191 12.868 11.9289 12.4844 12.1504L10.6201 13.2266C10.2365 13.4481 9.76354 13.4481 9.37988 13.2266L7.51562 12.1504C7.13202 11.9289 6.89551 11.5191 6.89551 11.0762V8.92383C6.89551 8.48085 7.13202 8.07113 7.51562 7.84961L9.37988 6.77344Z"
      stroke="white"
      style="stroke:white;stroke-opacity:1;"
      stroke-width="0.72"
      stroke-linejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_12570_70"
        x1="5.71423"
        y1="0.714234"
        x2="14.2857"
        y2="19.2857"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stop-color="#575757"
          style="stop-color:#575757;stop-color:color(display-p3 0.3400 0.3400 0.3400);stop-opacity:1;"
        />
        <stop
          offset="1"
          stop-color="#1C1C1C"
          style="stop-color:#1C1C1C;stop-color:color(display-p3 0.1100 0.1100 0.1100);stop-opacity:1;"
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_12570_70"
        x1="13.9285"
        y1="16.7857"
        x2="4.6428"
        y2="3.21423"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stop-color="white"
          stop-opacity="0"
          style="stop-color:none;stop-opacity:0;"
        />
        <stop
          offset="1"
          stop-color="white"
          style="stop-color:white;stop-opacity:1;"
        />
      </linearGradient>
      <linearGradient
        id="paint2_linear_12570_70"
        x1="9.99995"
        y1="0.714233"
        x2="9.99995"
        y2="19.2857"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stop-opacity="0.68"
          style="stop-color:black;stop-opacity:0.68;"
        />
        <stop
          offset="1"
          style="stop-color:black;stop-opacity:1;"
        />
      </linearGradient>
      <linearGradient
        id="paint3_linear_12570_70"
        x1="9.99998"
        y1="3.57141"
        x2="9.99998"
        y2="16.4286"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stop-color="#1A1A1A"
          stop-opacity="0.68"
          style="stop-color:#1A1A1A;stop-color:color(display-p3 0.1000 0.1000 0.1000);stop-opacity:0.68;"
        />
        <stop
          offset="1"
          stop-color="#1A1A1A"
          style="stop-color:#1A1A1A;stop-color:color(display-p3 0.1000 0.1000 0.1000);stop-opacity:1;"
        />
      </linearGradient>
      <linearGradient
        id="paint4_linear_12570_70"
        x1="9.99998"
        y1="3.57141"
        x2="9.99998"
        y2="16.4286"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stop-color="white"
          style="stop-color:white;stop-opacity:1;"
        />
        <stop
          offset="1"
          stop-color="white"
          stop-opacity="0.6"
          style="stop-color:white;stop-opacity:0.6;"
        />
      </linearGradient>
    </defs></svg>
</template>

<script>
export default {
  name: 'LensCreditIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>
